export const PENSION = {
  isHidden: true,
  nickname: 'PRODUCTS.PENSION.nickname',
  icon:'pension'
};
